export class PasswordConfig {
    /**
 *
 *
 */
    readonly blockListInputSelectors = new Map<string, string>();
}

